/* ============================================================
   Véloria Piercing — Product Page JS
   Variants · Gallery · Timer · Modal · Accordions · Stock
   ============================================================ */
(function () {
  'use strict';

  /* Scroll a slider to a specific slide — works on iOS Safari (no inline scrollIntoView) */
  function scrollSliderToSlide(slider, slide) {
    var delta = slide.getBoundingClientRect().left - slider.getBoundingClientRect().left;
    slider.scrollTo({ left: slider.scrollLeft + delta, behavior: 'smooth' });
  }

  /* ── 1. MOBILE GALLERY SCROLL DOTS ───────────────────────── */
  function initGalleryDots() {
    var slider = document.querySelector('.v-prod__gallery-slider');
    var dots   = document.querySelectorAll('.v-prod__gallery-dot');
    if (!slider || !dots.length) return;

    var slides = slider.querySelectorAll('.v-prod__gallery-slide');
    if (!slides.length) return;

    function activeSlideIndex() {
      var sliderLeft = slider.getBoundingClientRect().left;
      var closest = 0;
      var minDist = Infinity;
      slides.forEach(function (slide, i) {
        var dist = Math.abs(slide.getBoundingClientRect().left - sliderLeft);
        if (dist < minDist) { minDist = dist; closest = i; }
      });
      return closest;
    }

    function updateDot() {
      var idx = activeSlideIndex();
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
    }

    slider.addEventListener('scroll', updateDot, { passive: true });
    dots[0].classList.add('is-active');

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        scrollSliderToSlide(slider, slides[i]);
      });
    });
  }

  /* ── 2. VARIANT PICKER ───────────────────────────────────── */
  function initVariants() {
    var form    = document.getElementById('v-prod-form');
    var varData = document.getElementById('v-prod-variants-json');
    if (!form || !varData) return;

    var variants     = JSON.parse(varData.textContent);
    var hiddenId     = form.querySelector('[name="id"]');
    var currentVariant = variants[0];

    /* Find variant by matching all option values */
    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      }) || null;
    }

    /* Collect current selected options across all pickers */
    function getSelectedOptions() {
      var selected = [];
      form.querySelectorAll('[data-option-index]').forEach(function (el) {
        var idx = parseInt(el.dataset.optionIndex);
        if (el.tagName === 'SELECT') {
          if (el.value) selected[idx] = el.value;
        } else if (el.classList.contains('is-selected')) {
          selected[idx] = el.dataset.value;
        }
      });
      return selected;
    }

    /* Update the option label span next to the option name */
    function updateOptionLabel(optionIndex, value) {
      var span = document.getElementById('v-opt-val-' + optionIndex);
      if (span) span.textContent = value;
    }

    /* Update price display */
    function updatePrice(v) {
      var priceEl   = document.querySelector('.v-prod__price');
      var compareEl = document.querySelector('.v-prod__price-compare');
      var saveEl    = document.querySelector('.v-prod__price-save');
      if (!priceEl || !v) return;

      var price = (v.price / 100).toFixed(2).replace('.', ',') + ' €';
      priceEl.innerHTML = price;

      if (v.compare_at_price && v.compare_at_price > v.price) {
        var cmp = (v.compare_at_price / 100).toFixed(2).replace('.', ',') + ' €';
        if (compareEl) { compareEl.textContent = cmp; compareEl.hidden = false; }
        if (saveEl) {
          var pct = Math.round((1 - v.price / v.compare_at_price) * 100);
          saveEl.textContent = '-' + pct + '%';
          saveEl.hidden = false;
        }
      } else {
        if (compareEl) compareEl.hidden = true;
        if (saveEl) saveEl.hidden = true;
      }
    }

    /* Update stock display */
    function updateStock(v) {
      var wrap = document.querySelector('.v-prod__stock');
      var dot  = document.querySelector('.v-prod__stock-dot');
      var msg  = document.querySelector('.v-prod__stock-msg');
      if (!wrap || !v) return;

      var low  = parseInt(wrap.dataset.lowThreshold || '5');
      var tIn  = wrap.dataset.textIn  || 'En stock';
      var tLow = wrap.dataset.textLow || 'Stock limité';
      var tOut = wrap.dataset.textOut || 'Indisponible';

      if (!v.available) {
        dot.className = 'v-prod__stock-dot v-prod__stock-dot--out';
        dot.classList.remove('is-pulse');
        if (msg) msg.textContent = tOut;
      } else if (v.inventory_management === 'shopify' && v.inventory_quantity <= low) {
        dot.className = 'v-prod__stock-dot v-prod__stock-dot--low is-pulse';
        if (msg) msg.textContent = tLow;
      } else {
        dot.className = 'v-prod__stock-dot v-prod__stock-dot--in is-pulse';
        if (msg) msg.textContent = tIn;
      }
    }

    /* Update ATC button */
    function updateAtc(v) {
      var btn    = form.querySelector('.v-prod__atc');
      var dynPay = document.querySelector('.v-prod__dynamic-payment');
      if (!btn) return;
      var available = v && v.available;
      btn.disabled = !available;
      if (dynPay) dynPay.style.display = available ? '' : 'none';
    }

    /* Update gallery main image when variant changes */
    function updateGalleryImage(v, optIdx, optVal) {
      var img = null;

      /* 1st: use the exact variant's featured image */
      if (v && v.featured_image) {
        img = v.featured_image;
      } else if (optIdx !== undefined && optVal !== undefined) {
        /* 2nd: find any variant with same option value that has an image */
        var match = variants.find(function (vv) {
          return vv.options[optIdx] === optVal && vv.featured_image;
        });
        if (match) img = match.featured_image;
      }

      if (!img) return;

      /* Desktop: replace main image src */
      var mainImg = document.querySelector('.v-prod__gallery-main img');
      if (mainImg) {
        mainImg.src    = img.src;
        mainImg.srcset = '';
      }

      /* Sticky thumbnail: update on variant change */
      var stickyThumb = document.querySelector('.v-prod__sticky-thumb img');
      if (stickyThumb && img.src) { stickyThumb.src = img.src; }

      /* Mobile: scroll slider to the matching slide */
      var slider = document.querySelector('.v-prod__gallery-slider');
      if (!slider) return;

      var slides = slider.querySelectorAll('.v-prod__gallery-slide');
      if (!slides.length) return;

      /* Normalize a Shopify CDN URL: remove query params and size suffix (_800x / _800x600) */
      function normSrc(src) {
        return (src || '').split('?')[0].replace(/_\d+x\d*(?=\.\w+$)/, '').toLowerCase();
      }

      var imgId   = String(img.id);
      var imgPos  = img.position ? String(img.position - 1) : null; /* 1-based → 0-based */
      var srcBase = normSrc(img.src);
      var found   = false;

      /* Pass 1 — position-based (most reliable: position maps directly to slide index) */
      if (!found && imgPos !== null && slides[img.position - 1]) {
        scrollSliderToSlide(slider, slides[img.position - 1]);
        found = true;
      }

      /* Pass 2 — ID / src fallback */
      if (!found) {
        for (var i = 0; i < slides.length; i++) {
          var slideImg = slides[i].querySelector('img[data-media-id]');
          if (!slideImg) continue;
          var matchId  = slideImg.getAttribute('data-img-id') === imgId ||
                         slideImg.getAttribute('data-media-id') === imgId;
          var matchSrc = srcBase.length > 10 && normSrc(slideImg.getAttribute('src')) === srcBase;
          if (matchId || matchSrc) {
            scrollSliderToSlide(slider, slides[i]);
            break;
          }
        }
      }
    }

    /* Mark button/swatch as selected; mark unavailable combos */
    function updateOptionUi(optionIndex, selectedValue) {
      var selector = '[data-option-index="' + optionIndex + '"]';
      document.querySelectorAll(selector).forEach(function (el) {
        if (el.tagName === 'SELECT') return; /* handled natively */
        var val      = el.dataset.value;
        var testOpts = getSelectedOptions();
        testOpts[optionIndex] = val;
        var matched  = findVariant(testOpts);
        el.classList.toggle('is-selected',   val === selectedValue);
        el.classList.toggle('is-unavailable', !matched || !matched.available);
      });
    }

    /* Sync overlay panel après changement de variante */
    function syncOverlay(v) {
      var price = v ? (v.price / 100).toFixed(2).replace('.', ',') + ' €' : '';

      /* Prix overlay */
      var ovlPrice = document.getElementById('v-ovl-price');
      if (ovlPrice) ovlPrice.textContent = price;

      /* Prix barré overlay */
      var ovlCmp = document.getElementById('v-ovl-compare');
      if (ovlCmp) {
        if (v && v.compare_at_price && v.compare_at_price > v.price) {
          ovlCmp.textContent = (v.compare_at_price / 100).toFixed(2).replace('.', ',') + ' €';
          ovlCmp.hidden = false;
        } else {
          ovlCmp.hidden = true;
        }
      }

      /* Mini-swatches overlay */
      var mainSw = document.querySelectorAll('.v-prod__variants .v-prod__swatch');
      var miniSw = document.querySelectorAll('#v-ovl-variants .v-prod__ovl-swatch');
      mainSw.forEach(function(sw, i) {
        if (miniSw[i]) miniSw[i].classList.toggle('is-selected', sw.classList.contains('is-selected'));
      });

      /* Sync pills non-couleur (mode variante unique) */
      var ovlPills = document.querySelectorAll('#v-ovl-variants .v-prod__ovl-opt-pill');
      ovlPills.forEach(function(pill) {
        var idx = pill.dataset.optionIndex;
        var val = pill.dataset.value;
        var orig = document.querySelector(
          '.v-prod__variants .v-prod__option-btn[data-option-index="' + idx + '"][data-value="' + CSS.escape(val) + '"]'
        );
        if (orig) {
          pill.classList.toggle('is-selected', orig.classList.contains('is-selected'));
          pill.classList.toggle('is-unavailable', orig.classList.contains('is-unavailable'));
        }
      });

      /* Sync selects (mode multi-variantes) */
      document.querySelectorAll('#v-ovl-variants .v-prod__ovl-select').forEach(function(ovlSel) {
        var idx = ovlSel.dataset.optionIndex;
        var selBtn = document.querySelector(
          '.v-prod__variants .v-prod__option-btn[data-option-index="' + idx + '"].is-selected'
        );
        var mainSel = document.querySelector(
          '.v-prod__variants select[data-option-index="' + idx + '"]'
        );
        if (selBtn)    ovlSel.value = selBtn.dataset.value;
        else if (mainSel)   ovlSel.value = mainSel.value;
      });

      /* Sync miniature couleur + items modal (mode multi-variantes) */
      document.querySelectorAll('#v-ovl-variants .v-prod__ovl-color-thumb').forEach(function(thumb) {
        var idx = parseInt(thumb.dataset.optionIndex);
        var selSwatch = document.querySelector(
          '.v-prod__variants .v-prod__swatch[data-option-index="' + idx + '"].is-selected,' +
          '.v-prod__variants .v-prod__variant-thumb[data-option-index="' + idx + '"].is-selected'
        );
        if (!selSwatch) return;
        var val = selSwatch.dataset.value;
        /* Mise à jour miniature */
        var varData2 = document.getElementById('v-prod-variants-json');
        var allV = varData2 ? JSON.parse(varData2.textContent) : [];
        var match = allV.find(function(vv) { return vv.options[idx] === val && vv.featured_image; });
        var src = match ? match.featured_image.src : null;
        if (!src) {
          var swImg = selSwatch.querySelector('img');
          if (swImg && swImg.src) src = swImg.src;
        }
        var img = thumb.querySelector('img');
        if (src) {
          if (!img) { img = document.createElement('img'); img.alt = ''; thumb.appendChild(img); }
          img.src = src; thumb.style.background = '';
        } else {
          if (img) img.remove();
          thumb.style.background = selSwatch.style.background || '';
        }
        /* Mise à jour items modal */
        var modal = document.querySelector('.v-prod__color-modal[data-option-index="' + idx + '"]');
        if (modal) {
          modal.querySelectorAll('.v-prod__color-modal-item').forEach(function(it) {
            it.classList.toggle('is-selected', it.dataset.value === val);
          });
        }
      });

      /* ATC overlay disabled */
      var ovlAtc = document.getElementById('v-ovl-atc');
      if (ovlAtc) ovlAtc.disabled = !(v && v.available);
    }

    /* Apply a variant selection (shared logic) */
    function applySelection(idx, val) {
      var opts = getSelectedOptions();
      opts[idx] = val;
      var v = findVariant(opts);
      if (v) {
        currentVariant = v;
        hiddenId.value = v.id;
        updatePrice(v);
        updateStock(v);
        updateAtc(v);
        updateGalleryImage(v, idx, val);
        updateOptionUi(idx, val);
        updateOptionLabel(idx, val);
        syncOverlay(v);
      }
    }

    /* Button / swatch click */
    form.addEventListener('click', function (e) {
      var el = e.target.closest('[data-option-index]');
      if (!el || el.tagName === 'SELECT') return;
      e.preventDefault();

      var idx = parseInt(el.dataset.optionIndex);
      var val = el.dataset.value;

      /* Deselect siblings */
      form.querySelectorAll('[data-option-index="' + idx + '"]').forEach(function (s) {
        s.classList.remove('is-selected');
      });
      el.classList.add('is-selected');

      applySelection(idx, val);
    });

    /* SELECT dropdown change */
    form.addEventListener('change', function (e) {
      var el = e.target;
      if (el.tagName !== 'SELECT' || !el.dataset.optionIndex) return;
      applySelection(parseInt(el.dataset.optionIndex), el.value);
    });

    /* ATC click animation */
    var atcWrap = form.querySelector('.v-prod__atc-wrap');
    var atcBtn  = form.querySelector('.v-prod__atc');
    if (atcWrap && atcBtn) {
      var atcAnimTimer = null;
      form.addEventListener('submit', function () {
        if (atcBtn.disabled) return;
        atcWrap.classList.remove('is-added');
        void atcWrap.offsetWidth; /* force reflow to restart animation */
        atcWrap.classList.add('is-added');
        clearTimeout(atcAnimTimer);
        atcAnimTimer = setTimeout(function () { atcWrap.classList.remove('is-added'); }, 2200);
      });
    }

    /* Init on page load */
    if (currentVariant) {
      hiddenId.value = currentVariant.id;
      updatePrice(currentVariant);
      updateStock(currentVariant);
      updateAtc(currentVariant);
    }
  }

  /* ── 3. QUANTITY STEPPER ─────────────────────────────────── */
  function initQty() {
    var wrap = document.querySelector('.v-prod__qty');
    if (!wrap) return;
    var input  = wrap.querySelector('.v-prod__qty-input');
    var btnMin = wrap.querySelector('[data-qty="minus"]');
    var btnPls = wrap.querySelector('[data-qty="plus"]');
    if (!input) return;

    function clamp(v) { return Math.max(1, Math.min(99, v)); }

    btnMin && btnMin.addEventListener('click', function () {
      input.value = clamp(parseInt(input.value) - 1);
    });
    btnPls && btnPls.addEventListener('click', function () {
      input.value = clamp(parseInt(input.value) + 1);
    });
    input.addEventListener('change', function () {
      input.value = clamp(parseInt(input.value) || 1);
    });
  }

  /* ── 4. DESCRIPTION EXPAND/COLLAPSE ──────────────────────── */
  function initDescToggle() {
    var desc   = document.querySelector('.v-prod__desc');
    var toggle = document.querySelector('.v-prod__desc-toggle');
    var fade   = document.querySelector('.v-prod__desc-fade');
    if (!desc || !toggle) return;

    var textMore = toggle.dataset.textMore || 'Lire la suite';
    var textLess = toggle.dataset.textLess || 'Réduire';
    var lines    = parseInt(desc.dataset.lines || '4');
    var lineH    = parseFloat(getComputedStyle(desc).lineHeight) || 21;

    desc.style.setProperty('--desc-max-h', (lines * lineH) + 'px');
    desc.classList.add('is-collapsed');

    if (desc.scrollHeight <= desc.offsetHeight + 4) {
      toggle.style.display = 'none';
      if (fade) fade.style.display = 'none';
      return;
    }

    var open = false;
    toggle.addEventListener('click', function () {
      open = !open;
      desc.classList.toggle('is-collapsed', !open);
      if (fade) fade.style.opacity = open ? '0' : '1';
      toggle.innerHTML = open
        ? '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="18 15 12 9 6 15"/></svg> ' + textLess
        : '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="6 9 12 15 18 9"/></svg> ' + textMore;
    });

    toggle.innerHTML = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="6 9 12 15 18 9"/></svg> ' + textMore;
  }

  /* ── 5. ACCORDIONS ───────────────────────────────────────── */
  function initAccordions() {
    document.querySelectorAll('.v-prod__accordion-trigger').forEach(function (trigger) {
      var accordion = trigger.closest('.v-prod__accordion');
      if (!accordion) return;

      if (accordion.dataset.openDefault === 'true') {
        accordion.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      }

      trigger.addEventListener('click', function () {
        var isOpen = accordion.classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });
  }

  /* ── 6. MODAL GUIDES ─────────────────────────────────────── */
  function initModals() {
    var overlay  = document.querySelector('.v-prod__modal-overlay');
    var modal    = document.querySelector('.v-prod__modal');
    var closeBtn = document.querySelector('.v-prod__modal-close');
    var titleEl  = document.querySelector('.v-prod__modal-title');
    var bodyEl   = document.querySelector('.v-prod__modal-body');
    if (!overlay || !modal) return;

    var previouslyFocused = null;

    function openModal(title, content) {
      previouslyFocused = document.activeElement;
      if (titleEl) titleEl.textContent = title;
      if (bodyEl)  bodyEl.innerHTML    = content;
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      setTimeout(function () {
        var first = modal.querySelector('button, a, input, [tabindex]');
        if (first) first.focus();
      }, 100);
    }

    function closeModal() {
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (previouslyFocused) previouslyFocused.focus();
    }

    document.querySelectorAll('[data-modal-trigger]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openModal(btn.dataset.modalTitle || '', btn.dataset.modalContent || '');
      });
    });

    closeBtn && closeBtn.addEventListener('click', closeModal);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeModal();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeModal();
    });

    modal.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var focusable = modal.querySelectorAll(
        'button:not([disabled]), a[href], input, [tabindex]:not([tabindex="-1"])'
      );
      if (!focusable.length) return;
      var first = focusable[0];
      var last  = focusable[focusable.length - 1];
      if (e.shiftKey) {
        if (document.activeElement === first) { e.preventDefault(); last.focus(); }
      } else {
        if (document.activeElement === last)  { e.preventDefault(); first.focus(); }
      }
    });
  }

  /* ── 7. COUNTDOWN TIMER ──────────────────────────────────── */
  function initTimer() {
    var timerEl = document.querySelector('.v-prod__timer-digits');
    if (!timerEl) return;

    var mode      = timerEl.dataset.mode     || 'session';
    var duration  = parseInt(timerEl.dataset.duration) || 60;
    var endDate   = timerEl.dataset.endDate;
    var storageKey = 'veloria_timer_end';

    function getEndTime() {
      if (mode === 'fixed' && endDate) return new Date(endDate).getTime();

      var stored = sessionStorage.getItem(storageKey + '_' + mode);
      if (mode === 'session') {
        if (stored) return parseInt(stored);
        var end = Date.now() + duration * 60000;
        sessionStorage.setItem(storageKey + '_session', end);
        return end;
      }
      if (mode === 'daily') {
        var today     = new Date().toDateString();
        var storedDay = localStorage.getItem(storageKey + '_day');
        var storedEnd = localStorage.getItem(storageKey + '_daily');
        if (storedEnd && storedDay === today) return parseInt(storedEnd);
        var end2 = Date.now() + duration * 60000;
        localStorage.setItem(storageKey + '_daily', end2);
        localStorage.setItem(storageKey + '_day', today);
        return end2;
      }
      return Date.now() + duration * 60000;
    }

    var endTime = getEndTime();
    function pad(n) { return String(n).padStart(2, '0'); }

    function tick() {
      var remaining = endTime - Date.now();
      if (remaining <= 0) { timerEl.textContent = '00:00:00'; return; }
      var h = Math.floor(remaining / 3600000);
      var m = Math.floor((remaining % 3600000) / 60000);
      var s = Math.floor((remaining % 60000) / 1000);
      timerEl.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
      setTimeout(tick, 1000);
    }
    tick();
  }

  /* ── 8. OVERLAY PANEL — MOBILE ───────────────────────────── */
  function initOverlay() {
    var overlay = document.getElementById('v-overlay');
    var atcBtn  = document.querySelector('.v-prod__atc');
    if (!overlay || !atcBtn) return;

    var thumbSize = parseInt(overlay.dataset.colorThumbSize || '80');

    /* Lit les variants JSON pour les images de chaque couleur */
    var varData = document.getElementById('v-prod-variants-json');
    var allVariants = varData ? JSON.parse(varData.textContent) : [];

    /* Extraire le texte du label de groupe (ignore le <span> enfant) */
    function groupLabelText(group) {
      var el = group.querySelector('.v-prod__variant-label');
      if (!el) return '';
      var text = '';
      el.childNodes.forEach(function(n) { if (n.nodeType === 3) text += n.textContent; });
      return text.trim().replace(/:$/, '').trim();
    }

    /* Trouver l'image d'une valeur de couleur donnée */
    function colorImg(optIdx, value) {
      var v = allVariants.find(function(v) {
        return v.options[optIdx] === value && v.featured_image;
      });
      return v ? v.featured_image.src : null;
    }

    /* Conteneur couleur : .v-prod__swatches OU .v-prod__variant-thumbs */
    function getColorContainer(group) {
      return group.querySelector('.v-prod__swatches, .v-prod__variant-thumbs');
    }
    /* Tous les boutons couleur d'un groupe */
    function getColorBtns(group) {
      var c = getColorContainer(group);
      return c ? Array.from(c.querySelectorAll('button[data-value]')) : [];
    }
    /* Image d'un bouton couleur : <img> propre en priorité, sinon variants JSON */
    function getBtnSrc(btn, optIdx) {
      var img = btn.querySelector('img');
      if (img && img.src) return img.src;
      return colorImg(optIdx, btn.dataset.value);
    }

    /* Mettre à jour la miniature couleur du sticky */
    function updateColorThumb(optIdx, value, src, bg) {
      var thumb = document.querySelector('.v-prod__ovl-color-thumb[data-option-index="' + optIdx + '"]');
      if (!thumb) return;
      var img = thumb.querySelector('img');
      if (src) {
        if (!img) { img = document.createElement('img'); img.alt = ''; thumb.appendChild(img); }
        img.src = src; thumb.style.background = '';
      } else {
        if (img) img.remove();
        thumb.style.background = bg || '';
      }
    }

    /* Construire la modal couleur (colorBtns = boutons originaux du groupe) */
    function buildColorModal(colorBtns, optIdx, labelTxt, thumbBtn) {
      var modal = document.createElement('div');
      modal.className = 'v-prod__color-modal';
      modal.setAttribute('aria-hidden', 'true');
      modal.dataset.optionIndex = optIdx;

      var backdrop = document.createElement('div');
      backdrop.className = 'v-prod__color-modal-backdrop';

      var panel = document.createElement('div');
      panel.className = 'v-prod__color-modal-panel';

      var handle = document.createElement('div');
      handle.className = 'v-prod__color-modal-handle';

      var header = document.createElement('div');
      header.className = 'v-prod__color-modal-header';
      var titleSpan = document.createElement('span');
      titleSpan.textContent = labelTxt || 'Couleur';
      var closeBtn = document.createElement('button');
      closeBtn.type = 'button';
      closeBtn.className = 'v-prod__color-modal-close';
      closeBtn.innerHTML = '&times;';
      header.appendChild(titleSpan);
      header.appendChild(closeBtn);

      /* Détecte si les boutons sont des swatches image personnalisés */
      var isImgSwatch = colorBtns.length > 0 && colorBtns[0].classList.contains('v-prod__swatch--img');

      var grid = document.createElement('div');
      grid.className = 'v-prod__color-modal-grid' + (isImgSwatch ? ' v-prod__color-modal-grid--circle' : '');
      grid.style.setProperty('--modal-thumb-size', thumbSize + 'px');

      colorBtns.forEach(function(origBtn) {
        var val = origBtn.dataset.value;
        var src = getBtnSrc(origBtn, optIdx);
        var bg  = origBtn.style.background || '';

        var item = document.createElement('button');
        item.type = 'button';
        item.className = 'v-prod__color-modal-item' +
          (isImgSwatch ? ' v-prod__color-modal-item--circle' : '') +
          (origBtn.classList.contains('is-selected') ? ' is-selected' : '');
        item.dataset.value = val;

        if (src) {
          var img = document.createElement('img');
          img.src = src; img.alt = val;
          item.appendChild(img);
        } else {
          var circle = document.createElement('span');
          circle.className = 'v-prod__color-modal-swatch';
          circle.style.background = bg;
          item.appendChild(circle);
        }

        var lbl = document.createElement('span');
        lbl.className = 'v-prod__color-modal-label';
        lbl.textContent = val;
        item.appendChild(lbl);

        item.addEventListener('click', function() {
          grid.querySelectorAll('.v-prod__color-modal-item').forEach(function(i) { i.classList.remove('is-selected'); });
          item.classList.add('is-selected');
          origBtn.click();
          if (thumbBtn) updateColorThumb(optIdx, val, src, bg);
          closeModal();
          scrollToGallery();
        });

        grid.appendChild(item);
      });

      panel.appendChild(handle);
      panel.appendChild(header);
      panel.appendChild(grid);
      modal.appendChild(backdrop);
      modal.appendChild(panel);
      document.body.appendChild(modal);

      function closeModal() {
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }
      backdrop.addEventListener('click', closeModal);
      closeBtn.addEventListener('click', closeModal);

      return modal;
    }

    /* Scroll vers la galerie image quand on change de variante depuis l'overlay */
    function scrollToGallery() {
      if (window.innerWidth > 900) return;
      document.body.style.overflowX = 'visible';
      document.documentElement.style.overflowX = 'visible';
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      setTimeout(function() {
        document.body.style.overflowX = '';
        document.documentElement.style.overflowX = '';
      }, 50);
    }

    /* Afficher/masquer l'overlay quand le ATC principal sort du viewport.
       Si le bouton d'achat est masqué en arrière-plan mobile (v-hide-mobile),
       l'overlay reste toujours visible — pas besoin d'observer. */
    var atcWrap = atcBtn.closest('.v-prod__atc-wrap');
    if (atcWrap && atcWrap.classList.contains('v-hide-mobile')) {
      overlay.classList.add('is-visible');
    } else {
      var obs = new IntersectionObserver(function(entries) {
        overlay.classList.toggle('is-visible', !entries[0].isIntersecting);
      }, { threshold: 0 });
      obs.observe(atcBtn);
    }

    /* Peupler #v-ovl-variants */
    var variantContainer = document.getElementById('v-ovl-variants');
    if (variantContainer) {
      var groups = document.querySelectorAll('.v-prod__variants .v-prod__variant-group');
      var isSingle = groups.length === 1;

      if (isSingle) {
        /* ── 1 seule variante : swatches, thumbnail-swatches ou pills ── */
        var group = groups[0];
        var colorBtnsSingle = getColorBtns(group); /* .v-prod__swatch OU .v-prod__variant-thumb */
        var swatchWrap = group.querySelector('.v-prod__swatches');

        var grp = document.createElement('div');
        grp.className = 'v-prod__ovl-opt-group';

        var lbl = document.createElement('span');
        lbl.className = 'v-prod__ovl-opt-label';
        lbl.textContent = groupLabelText(group);
        grp.appendChild(lbl);

        if (swatchWrap) {
          /* Style pastille (circle swatch, y compris swatches image) */
          var row = document.createElement('div');
          row.className = 'v-prod__ovl-swatches-row';
          swatchWrap.querySelectorAll('.v-prod__swatch').forEach(function(sw) {
            var mini = document.createElement('button');
            mini.type = 'button';
            mini.className = 'v-prod__ovl-swatch' + (sw.classList.contains('is-selected') ? ' is-selected' : '');
            mini.title = sw.title || '';
            mini.setAttribute('aria-label', sw.getAttribute('aria-label') || '');
            if (sw.classList.contains('v-prod__swatch--img')) {
              mini.classList.add('v-prod__ovl-swatch--img');
              var swImg = sw.querySelector('img');
              if (swImg) {
                var mi = document.createElement('img');
                mi.src = swImg.src; mi.alt = swImg.alt || '';
                mini.appendChild(mi);
              }
            } else {
              mini.style.cssText = sw.style.cssText;
            }
            mini.addEventListener('click', function() { sw.click(); scrollToGallery(); });
            row.appendChild(mini);
          });
          grp.appendChild(row);
        } else if (colorBtnsSingle.length) {
          /* Style thumbnail (image swatch) — miniature + modal */
          var firstSingle = colorBtnsSingle.find(function(b) { return b.classList.contains('is-selected'); }) || colorBtnsSingle[0];
          var optIdxSingle = firstSingle ? parseInt(firstSingle.dataset.optionIndex) : 0;
          var srcSingle = firstSingle ? getBtnSrc(firstSingle, optIdxSingle) : null;
          var bgSingle  = firstSingle ? (firstSingle.style.background || '') : '';

          var thumbSingle = document.createElement('button');
          var isImgSwatchSingle = colorBtnsSingle.length > 0 && colorBtnsSingle[0].classList.contains('v-prod__swatch--img');
          thumbSingle.type = 'button';
          thumbSingle.className = 'v-prod__ovl-color-thumb' + (isImgSwatchSingle ? ' v-prod__ovl-color-thumb--circle' : '');
          thumbSingle.dataset.optionIndex = optIdxSingle;
          if (srcSingle) {
            var tsi = document.createElement('img'); tsi.src = srcSingle; tsi.alt = '';
            thumbSingle.appendChild(tsi);
          } else { thumbSingle.style.background = bgSingle; }

          var modalSingle = buildColorModal(colorBtnsSingle, optIdxSingle, groupLabelText(group), thumbSingle);
          thumbSingle.addEventListener('click', function() {
            var cur = colorBtnsSingle.find(function(b) { return b.classList.contains('is-selected'); });
            modalSingle.querySelectorAll('.v-prod__color-modal-item').forEach(function(it) {
              it.classList.toggle('is-selected', !!(cur && it.dataset.value === cur.dataset.value));
            });
            modalSingle.classList.add('is-open');
            modalSingle.removeAttribute('aria-hidden');
            document.body.style.overflow = 'hidden';
          });
          grp.appendChild(thumbSingle);
        } else {
          /* Pills pour variantes sans couleur */
          var row2 = document.createElement('div');
          row2.className = 'v-prod__ovl-opts-row';
          group.querySelectorAll('.v-prod__option-btn').forEach(function(origBtn) {
            var pill = document.createElement('button');
            pill.type = 'button';
            pill.className = 'v-prod__ovl-opt-pill' +
              (origBtn.classList.contains('is-selected') ? ' is-selected' : '') +
              (origBtn.classList.contains('is-unavailable') ? ' is-unavailable' : '');
            pill.textContent = origBtn.textContent.trim();
            pill.dataset.optionIndex = origBtn.dataset.optionIndex;
            pill.dataset.value = origBtn.dataset.value;
            pill.addEventListener('click', function() { origBtn.click(); scrollToGallery(); });
            row2.appendChild(pill);
          });
          grp.appendChild(row2);
        }
        variantContainer.appendChild(grp);

      } else {
        /* ── Plusieurs variantes ── */
        groups.forEach(function(group) {
          var colorBtns = getColorBtns(group); /* swatch OU variant-thumb */
          var mainBtns  = group.querySelectorAll('.v-prod__option-btn');
          var mainSel   = group.querySelector('select');
          var labelTxt  = groupLabelText(group);
          var firstBtn  = colorBtns[0] || mainBtns[0];
          var optIdx    = firstBtn ? parseInt(firstBtn.dataset.optionIndex) : 0;

          if (colorBtns.length) {
            /* Groupe couleur → miniature + modal */
            var grp = document.createElement('div');
            grp.className = 'v-prod__ovl-color-group';
            var lbl = document.createElement('span');
            lbl.className = 'v-prod__ovl-opt-label';
            lbl.textContent = labelTxt;
            grp.appendChild(lbl);

            var selBtn = colorBtns.find(function(b) { return b.classList.contains('is-selected'); }) || colorBtns[0];
            var selSrc = selBtn ? getBtnSrc(selBtn, optIdx) : null;
            var selBg  = selBtn ? (selBtn.style.background || '') : '';

            var thumb = document.createElement('button');
            var isImgSwatchGroup = colorBtns.length > 0 && colorBtns[0].classList.contains('v-prod__swatch--img');
            thumb.type = 'button';
            thumb.className = 'v-prod__ovl-color-thumb' + (isImgSwatchGroup ? ' v-prod__ovl-color-thumb--circle' : '');
            thumb.dataset.optionIndex = optIdx;
            if (selSrc) {
              var ti = document.createElement('img'); ti.src = selSrc; ti.alt = '';
              thumb.appendChild(ti);
            } else { thumb.style.background = selBg; }

            var modal = buildColorModal(colorBtns, optIdx, labelTxt, thumb);

            thumb.addEventListener('click', function() {
              var cur = colorBtns.find(function(b) { return b.classList.contains('is-selected'); });
              modal.querySelectorAll('.v-prod__color-modal-item').forEach(function(it) {
                it.classList.toggle('is-selected', !!(cur && it.dataset.value === cur.dataset.value));
              });
              modal.classList.add('is-open');
              modal.removeAttribute('aria-hidden');
              document.body.style.overflow = 'hidden';
            });

            grp.appendChild(thumb);
            variantContainer.appendChild(grp);

          } else {
            /* Groupe non-couleur → select déroulant */
            var grp2 = document.createElement('div');
            grp2.className = 'v-prod__ovl-opt-group v-prod__ovl-opt-group--select';
            var lbl2 = document.createElement('span');
            lbl2.className = 'v-prod__ovl-opt-label';
            lbl2.textContent = labelTxt;
            grp2.appendChild(lbl2);

            var sel = document.createElement('select');
            sel.className = 'v-prod__ovl-select';

            if (mainBtns.length) {
              sel.dataset.optionIndex = mainBtns[0].dataset.optionIndex;
              mainBtns.forEach(function(btn) {
                var opt = document.createElement('option');
                opt.value = btn.dataset.value; opt.text = btn.textContent.trim();
                if (btn.classList.contains('is-selected')) opt.selected = true;
                sel.appendChild(opt);
              });
              sel.addEventListener('change', function() {
                var orig = group.querySelector('.v-prod__option-btn[data-value="' + CSS.escape(sel.value) + '"]');
                if (orig) orig.click();
                scrollToGallery();
              });
            } else if (mainSel) {
              sel.dataset.optionIndex = mainSel.dataset.optionIndex;
              Array.from(mainSel.options).forEach(function(o) {
                var opt = document.createElement('option');
                opt.value = o.value; opt.text = o.text;
                if (mainSel.value === o.value) opt.selected = true;
                sel.appendChild(opt);
              });
              sel.addEventListener('change', function() {
                mainSel.value = sel.value; mainSel.dispatchEvent(new Event('change'));
                scrollToGallery();
              });
            }

            grp2.appendChild(sel);
            variantContainer.appendChild(grp2);
          }
        });
      }
    }

    /* Bouton ATC overlay → ATC principal */
    var ovlAtc = document.getElementById('v-ovl-atc');
    if (ovlAtc) {
      ovlAtc.addEventListener('click', function() {
        if (!atcBtn.disabled) atcBtn.click();
      });
    }
  }

  /* ── 9. DESKTOP GALLERY MAIN IMAGE SWAP ON GRID CLICK ────── */
  function initGallerySwap() {
    var mainWrap = document.querySelector('.v-prod__gallery-main');
    if (!mainWrap) return;
    var mainImg = mainWrap.querySelector('img');
    if (!mainImg) return;

    document.querySelectorAll('.v-prod__gallery-grid .v-prod__gallery-item').forEach(function (item) {
      item.style.cursor = 'pointer';
      item.addEventListener('click', function () {
        var thumb = item.querySelector('img');
        if (!thumb) return;
        var tmp = { src: mainImg.src, srcset: mainImg.srcset, alt: mainImg.alt };
        mainImg.src    = thumb.src;
        mainImg.srcset = thumb.srcset || '';
        mainImg.alt    = thumb.alt;
        thumb.src    = tmp.src;
        thumb.srcset = tmp.srcset;
        thumb.alt    = tmp.alt;
        var mainLabel  = mainWrap.querySelector('.v-prod__img-label');
        var thumbLabel = item.querySelector('.v-prod__img-label');
        var ml = mainLabel  ? mainLabel.innerHTML  : '';
        var tl = thumbLabel ? thumbLabel.innerHTML : '';
        if (mainLabel)  mainLabel.innerHTML  = tl;
        if (thumbLabel) thumbLabel.innerHTML = ml;
      });
    });
  }

  /* ── 10. SCROLL REVEAL ───────────────────────────────────── */
  function registerReveal() {
    if (typeof window.veloria_observe === 'function') {
      document.querySelectorAll('.v-prod__gallery-item, .v-prod__buy').forEach(function (el) {
        window.veloria_observe(el);
      });
    }
  }

  /* ── INIT ─────────────────────────────────────────────────── */
  function init() {
    initGalleryDots();
    initVariants();
    initQty();
    initDescToggle();
    initAccordions();
    initModals();
    initTimer();
    initOverlay();
    initGallerySwap();
    registerReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
